import { getParams } from '../shared/utils.js';

const addScript = () => {
  const script = document.createElement('SCRIPT');
  script.src = '/wizard.js';
  document.body.appendChild(script);
};

const addPlacementId = () => {
  const params = getParams();
  const container = document.getElementById('md_wizard');
  container.dataset.placementId = params.placementId;
};

addPlacementId();
addScript();
